export default __webpack_public_path__ + "static/media/icon-application-testing.b4563f4c.svg";